import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecruitingService } from 'src/app/api/recruiting.service';
import { LocationRenewalData } from 'src/app/api/types/registration';
import { KnobModule } from 'primeng/knob';
import { FormsModule } from '@angular/forms';
import { UiModule } from 'src/app/ui/ui.module';

interface RenewalItem {
  data: LocationRenewalData;
  percentage: number;
  displayPercentage: number;
}

@Component({
  selector: 'app-renewal-progress',
  templateUrl: './renewal-progress.component.html',
  styleUrls: ['./renewal-progress.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    UiModule
  ]
})
export class RenewalProgressComponent implements OnInit {
  locationData: RenewalItem[] = [];
  overallData: RenewalItem | null = null;
  loading: boolean = true;
  error: string | null = null;

  constructor(private recruitingService: RecruitingService) { }

  ngOnInit(): void {
    this.loadRenewalData();
  }

  private loadRenewalData() {
    this.loading = true;
    this.error = null;

    this.recruitingService.getLocationRenewalData().subscribe({
      next: (data) => {
        // First item is overall data
        this.overallData = {
          data: data[0],
          percentage: this.getPercentage(data[0].renewalRate),
          displayPercentage: this.getDisplayPercentage(data[0].renewalRate)
        };
        // Rest are location-specific data
        this.locationData = data.slice(1).map(item => ({
          data: item,
          percentage: this.getPercentage(item.renewalRate),
          displayPercentage: this.getDisplayPercentage(item.renewalRate)
        }));
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Failed to load renewal data: ' + (err.message || 'Unknown error');
        this.loading = false;
      }
    });
  }

  private getPercentage(value: number): number {
    return Math.round(value * 100);
  }

  private getDisplayPercentage(value: number): number {
    let percentage = this.getPercentage(value);
    if (percentage > 100) percentage = 100;
    return percentage;
  }

  getKnobColor(percentage: number): string {
    return percentage < 100 ? 'rgba(28, 132, 198, 0.7)' : '#1ab394';
  }
} 